/** Состояния, которые нужны на каждом экране: загрузка, пусто, ошибка, офлайн. */
import type { ReactElement, ReactNode } from 'react';
import { t } from '../i18n';

export function Loading({ rows = 3, text }: { rows?: number; text?: string }): ReactElement {
  return (
    <div className="col" style={{ gap: 10 }}>
      {text ? (
        <div className="row" style={{ gap: 8 }}>
          <span className="spinner" />
          <span className="small muted">{text}</span>
        </div>
      ) : null}
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="skeleton" />
      ))}
    </div>
  );
}

export interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ErrorState({ message, onRetry, retryLabel }: ErrorStateProps): ReactElement {
  return (
    <div className="card">
      <div className="banner error">{message}</div>
      {onRetry ? (
        <button type="button" className="btn primary" onClick={onRetry}>
          {retryLabel ?? t('components.states.retry')}
        </button>
      ) : null}
    </div>
  );
}

export function EmptyState({
  title,
  hint,
  action,
}: {
  title: string;
  hint?: string;
  action?: ReactNode;
}): ReactElement {
  return (
    <div className="empty">
      <strong>{title}</strong>
      {hint ? <span className="small">{hint}</span> : null}
      {action}
    </div>
  );
}

export function OfflineBanner(): ReactElement {
  return (
    <div className="banner error" role="status">
      {t('components.states.offline')}
    </div>
  );
}
